import React, { FC, useState } from 'react';
import './ConfirmExpireIssuesDialog.scss';
import { Button, ButtonSize, ButtonTheme } from '../../shared/common/Button';
import ModalDialog from '../../shared/components/modal/ModalDialog';
import { ProductOut } from '../../store/api';
import { useTranslation } from 'react-i18next';
import { expireIssues } from '../../api/subscription-management/expireIssues';
import { invalidateManageSubscriptionData } from '../../api/subscription-management/useMagazinSubscriptionData';

type Props = {
    hidePopup: () => void;
    product: ProductOut;
};

export const ConfirmExpireIssuesDialog: FC<Props> = ({ hidePopup, product }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    return (
        <ModalDialog
            title={t('components.confirmExpireIssuesDialog.title', { title: product.title })}
            show={true}
            boldHeader={true}
            titleClassName="popup-title"
            onCloseButtonClick={!loading ? hidePopup : undefined}
        >
            <div className="confirm-expire-issues-dialog-content">
                <p>{t('components.confirmExpireIssuesDialog.description')}</p>

                <div className="footer">
                    <Button
                        theme={ButtonTheme.POSITIVE_INVERT}
                        disabled={loading}
                        onClick={hidePopup}
                        text={t('cancel')}
                        size={ButtonSize.LARGE}
                    />
                    <Button
                        size={ButtonSize.LARGE}
                        theme={ButtonTheme.POSITIVE}
                        disabled={loading}
                        text={t('components.confirmExpireIssuesDialog.submit')}
                        onClick={async () => {
                            setLoading(true);
                            try {
                                await expireIssues(product.id ?? '');
                            } finally {
                                await invalidateManageSubscriptionData();
                                hidePopup();
                                setLoading(false);
                            }
                        }}
                        isLoading={loading}
                    />
                </div>
            </div>
        </ModalDialog>
    );
};
